import { render, staticRenderFns } from "./UVLamp.vue?vue&type=template&id=6eb212b6&scoped=true&"
import script from "./UVLamp.vue?vue&type=script&lang=js&"
export * from "./UVLamp.vue?vue&type=script&lang=js&"
import style0 from "./UVLamp.vue?vue&type=style&index=0&id=6eb212b6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eb212b6",
  null
  
)

export default component.exports